import React, {useState} from 'react';
import {Box, InputBase} from '@mui/material';
import {useTranslate} from 'react-admin';
import {t} from '../themes/statamicTokens';
import PrimaryButton from '../components/statamic/PrimaryButton';

const MAX_LENGTH = 300;

const CommentInput = ({onSubmit, commentInputRef, commentId}) => {
    const translate = useTranslate();
    const [value, setValue] = useState('');

    const handleChange = (e) => setValue(e.target.value.slice(0, MAX_LENGTH));

    const handleSubmit = () => {
        if (!value.trim()) return;
        onSubmit?.(value, commentId);
        setValue('');
    };

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    px: 1.5,
                    py: 1,
                    borderRadius: `${t.radius.sm}px`,
                    border: `1px solid ${t.color.border.default}`,
                    backgroundColor: t.color.surface,
                    '&:focus-within': {
                        borderColor: t.color.accent.primary,
                        boxShadow: `0 0 0 3px ${t.color.accent.primaryTint}`,
                    },
                }}
            >
                <InputBase
                    fullWidth
                    multiline
                    maxRows={5}
                    value={value}
                    onChange={handleChange}
                    placeholder={translate('Leave a comment')}
                    inputRef={commentInputRef}
                    inputProps={{maxLength: MAX_LENGTH}}
                    sx={{
                        flex: 1,
                        fontSize: `${t.type.body.size}px`,
                        color: t.color.text.primary,
                    }}
                />
            </Box>
            <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <Box sx={{fontSize: `${t.type.caption.size}px`, color: t.color.text.muted}}>
                    {value.length} / {MAX_LENGTH}
                </Box>
                <PrimaryButton variant="primary" disabled={!value.trim()} onClick={handleSubmit}>
                    {translate('Post')}
                </PrimaryButton>
            </Box>
        </Box>
    );
};

export default CommentInput;
